module.exports = __webpack_public_path__ + "cf380648d83c0478ce5459cc646fec8a.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/fr/panic_fr.mp3
 ** module id = 644
 ** module chunks = 0
 **/